module.exports = ".modal-body.additive-value {\n  height: calc(24vh);\n  overflow-y: scroll; }\n\n.content-reposition {\n  top: 3vh;\n  width: 500px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/consultants/components/modalInputAdditiveValue/modal-input-value.component.scss
// module id = ./src/app/views/consultants/components/modalInputAdditiveValue/modal-input-value.component.scss
// module chunks = main